
export default [
  {
    path: '/region/card/create',
    name: 'card-create',
    component: () => import ('@/pages/card/create/index')
  },
  {
    path: '/region/card/stand',
    name: 'card-stand',
    component: r => require(['@/pages/card/stand'], r) 
  }
]


// WEBPACK FOOTER //
// ./src/router/card.js